import { renderSparkline, type SparkPoint } from "@bookboost/shared/chart";

interface SparklineProps {
  points: SparkPoint[];
  height?: number;
  width?: number;
  fill?: string;
  stroke?: string;
  peak?: boolean;
  caption?: string;
}

export function Sparkline({ points, height, width, fill, stroke, peak, caption }: SparklineProps) {
  // renderSparkline returns a complete <svg> string; the SVG is trusted markup
  // generated by our own server-shared helper, never user content.
  const svg = renderSparkline(points, { height, width, fill, stroke, peak });
  return (
    <figure className="spark-wrap">
      <span dangerouslySetInnerHTML={{ __html: svg }} />
      {caption && <figcaption className="spark-caption">{caption}</figcaption>}
    </figure>
  );
}
